import React, { Component } from "react";

// Components
import PageLoading from "../PageLoading";
import PageError from "../PageError";
import BadgeDetails from "./BadgeDetails";

class BadgeDetailsContainer extends Component {
  state = {
    loading: true,
    error: null,
    data: undefined,
    isModalOpen: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    this.setState({ loading: true, error: null });

    try {
      const api = await fetch(
        `https://us-central1-reactbadges.cloudfunctions.net/badge/${this.props.match.params.badgeId}`
        // `http://localhost:5001/reactbadges/us-central1/badge/${this.props.match.params.badgeId}`
      );
      const data = await api.json();
      data.id = this.props.match.params.badgeId;
      this.setState({ loading: false, data: data });
    } catch (error) {
      this.setState({ loading: false, error: error });
    }
  };

  handleOpenModal = () => {
    this.setState({
      isModalOpen: true,
    });
  };

  handleCloseModal = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  handleDeleteBadge = async () => {
    this.setState({ loading: true, error: null });
    try {
      await fetch(
        `https://us-central1-reactbadges.cloudfunctions.net/removeBadge/${this.props.match.params.badgeId}`
        // `http://localhost:5001/reactbadges/us-central1/removeBadge/${this.props.match.params.badgeId}`
        ,{
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' }
      });

      this.setState({ loading: false });
      this.props.history.push(`/badges`);
    } catch (error) {
      this.setState({ loading: false, error: error });
    }
  };

  render() {
    if (this.state.loading) {
      return <PageLoading />;
    }

    if (this.state.error) {
      return <PageError error={this.state.error} />;
    }

    return (
      <BadgeDetails
        onOpenModal={this.handleOpenModal}
        onCloseModal={this.handleCloseModal}
        onDeleteBadge={this.handleDeleteBadge}
        isModalOpen={this.state.isModalOpen}
        badge={this.state.data}
      />
    );
  }
}

export default BadgeDetailsContainer;
